import { ActionDatapoint } from 'owa-analytics';
import { PerformanceDatapoint } from 'owa-analytics';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "SearchActions" */ './lazyIndex');
});
export var lazyLoadSearchTable = new LazyAction(lazyModule, function (m) { return m.loadSearchTable; });
export var lazyCleanSearchTableState = new LazyAction(lazyModule, function (m) { return m.cleanSearchTableState; })
    .importAndExecute;
export var lazyLoadMoreFindItemSearch = new LazyImport(lazyModule, function (m) { return m.loadMoreFindItemSearch; });
export { ActionDatapoint, PerformanceDatapoint, };
//# sourceMappingURL=index.js.map